import { render } from "./HeroiconsSolidUsers.vue?vue&type=template&id=797b3b65"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidUsers.vue"]])

export default __exports__